import styles from './feature-idea.module.less';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface FeatureIdeaProps {}

export function FeatureIdea(props: FeatureIdeaProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_idea')}</h1>
    </div>
  );
}

export default FeatureIdea;
